import { render } from "./DevLogin.vue?vue&type=template&id=61476e62"
import script from "./DevLogin.vue?vue&type=script&lang=js"
export * from "./DevLogin.vue?vue&type=script&lang=js"

import "./DevLogin.vue?vue&type=style&index=0&id=61476e62&lang=scss"
script.render = render

export default script